// @flow

export const SERVER_SIDE = typeof window === "undefined"

export const s3img = (img: string) =>
    `https://s3-us-west-2.amazonaws.com/simplyrets/site/${img}`

export const docsLinkSrc = (path: ?string) =>
    `https://docs.simplyrets.com/api/index.html#${path ? path : ""}`
